<div class="wrapper">
  <div class="banner">
    <img [src]="banners[0]">
  </div>
</div>